import type { FC } from 'react';
import { Flex, Skeleton } from '@eqi-investimentos/react';
import { type AuthorProgram } from '@/modules/Author/interface/Author';
import { useT } from '@/libs/i18n/utils/useT';
import { WidgetContainer } from '@/components/modules/Widget/Container';
import { MostViewedCard } from '@/modules/Entertainment/ui/Widgets/MostViewed/Card';

export const AuthorPrograms: FC<AuthorProgramsProps> = ({
  authorName,
  isLoading,
  programs,
}) => {
  const t = useT();

  if (isLoading) {
    return (
      <Flex flexDir="column" w="full" gap="1.125rem">
        <Skeleton w="11.875rem" h="1rem" borderRadius="0.3125rem" />
        <Flex w="full" gap="1.4375rem">
          {Array.from({ length: 3 }).map((_, idx) => (
            <Skeleton key={idx} w="348px" h="124px" borderRadius="0.5rem" />
          ))}
        </Flex>
      </Flex>
    );
  }

  if (programs.length === 0) {
    return <></>;
  }

  return (
    <WidgetContainer
      containerId="author-programs-slider"
      title={`${t('attributes.contents')} ${t('attributes.with')} ${authorName.split(' ')[0]}`}
      containerSxProps={{
        '>div>p': { lineHeight: 8 },
        '>div:nth-of-type(2)>div': { pr: '3.25rem' },
      }}
      removeSeeAllButton
    >
      {programs.map((program) => (
        <MostViewedCard
          key={program.id}
          programType={program?.type}
          slug={program.slug}
          thumb={program.thumb}
          title={program.title}
          type={program?.object}
          category={
            program?.type === 'recommendation'
              ? 'Research'
              : program?.type_trans
          }
        />
      ))}
    </WidgetContainer>
  );
};

type AuthorProgramsProps = {
  authorName: string;
  isLoading: boolean;
  programs: AuthorProgram[];
};
